import { User } from "../users/user.class";

export class ResetPassword {
  constructor(
    public password: string = "",
    public passwordConfirm: string = "",
    public token: string = ""
  ) {}
}
